/* @flow */
import { Record, Map } from 'immutable'

const UsersRecord = Record(
  {
    id: '',
    createdAt: 0,
    updatedAt: 0,
    username: '', // used with @
    displayName: '',
    organization: null,
    organizationRole: 'member',
    email: '',
    photoURL: null,
    archivedAt: null,
    ssoEnabledAt: null,
    inviterId: null,
    invitePending: false,
    inviteCreatedAt: null,
    inviteAcceptedAt: null,
    channels: Map(),
    presence: Map(),
    oauthProvider: null,
    hasOauth: false,
    isBot: false,
    intercomIdentifierHash: null,
    abFlags: [],
  },
  'user'
)

export const UserConnectionRecord = Record(
  {
    id: null,
    totalCount: null,
    nodes: null,
  },
  'userConnection'
)

export default UsersRecord

export function createFromRaw(rawUser) {
  return new UsersRecord(rawUser)
}

export function isArchived(user) {
  return !!user.archivedAt
}

export function isInvited(user) {
  return user.invitePending
}

export function getLabel(user) {
  if (!user) {
    return 'someone'
  }
  return isArchived(user) ? '(deleted user)' : user.displayName
}

export function isOwner(user) {
  return user.organizationRole === 'owner'
}
